<template>
    <div id="group_detail_edit" v-if="status.show">
        <div class="main_between cross_top">
            <div class="left_col">
                <div class="left_cont">
                    <a-form-model
                        ref="group_detail_edit_form_rule"
                        :model="form"
                        :rules="formRule"
                        :label-col="{ span: 5 }"
                        :wrapper-col="{ span: 19 }"
                        labelAlign="left"
                    >
                        <a-form-model-item label="活动名称" prop="name">
                            <a-input
                                v-model="form.name"
                                placeholder="请输入活动名称"
                                :addon-after="form.name.length + '/10'"
                                @change="inputChange('name', 10)"
                            />
                        </a-form-model-item>
                        <a-form-model-item label="活动场景" prop="scene">
                            <a-input
                                v-model="form.scene"
                                placeholder="请输入活动场景"
                                :addon-after="form.scene.length + '/30'"
                                @change="inputChange('scene', 30)"
                            />
                        </a-form-model-item>
                        <a-form-model-item label="引导语" prop="guide">
                            <a-input
                                v-model="form.guide"
                                placeholder="请输入引导语"
                                :addon-after="form.guide.length + '/30'"
                                @change="inputChange('guide', 30)"
                            />
                        </a-form-model-item>
                        <a-form-model-item label="活动头像" prop="logo">
                            <div class="dir_left_wrap cross_center">
                                <a-upload
                                    accept=".jpg, .jpeg, .png"
                                    :action="`${baseUrl}/material/upload_cover`"
                                    :headers="headers"
                                    :showUploadList="false"
                                    :before-upload="beforeUpload"
                                    @change="uploadCoverChange"
                                >
                                    <div class="upload_list_item" v-if="form.logo">
                                        <div class="upload_list_item_info">
                                            <a-spin v-if="loading">
                                                <a-icon slot="indicator" type="loading" spin />
                                            </a-spin>
                                            <img :src="form.logo" width="80" height="80" v-else />
                                            <span
                                                class="upload_list_item_icon base_font_size_12"
                                                style="margin-left: 5px;"
                                            >
                                                <a-icon type="upload"></a-icon> 修改
                                            </span>
                                        </div>
                                    </div>
                                    <a-button :loading="loading" icon="upload" v-else>
                                        上传图片
                                    </a-button>
                                </a-upload>
                                <div
                                    class="base_font_color_00025 base_font_size_12"
                                    style="line-height: 1.5;padding-left: 15px;margin-top: -2px;"
                                >
                                    支持jpg/png格式图片，大小不超过2M
                                </div>
                            </div>
                        </a-form-model-item>
                        <a-form-model-item label="无法进群提示" prop="isTip">
                            <div class="dir_left_wrap cross_center" style="margin-top: 4px;">
                                <a-switch
                                    :checked="form.isTip === 1 ? true : false"
                                    @change="changeSwitch"
                                />
                                <div
                                    class="base_font_color_00025 base_font_size_12"
                                    style="line-height: 1.5;padding-left: 15px;"
                                >
                                    开启后，将在跳转页面底部显示无法进群的提示按钮
                                </div>
                            </div>
                        </a-form-model-item>
                        <template v-if="form.isTip === 1">
                            <a-form-model-item label="提示语" prop="tip">
                                <a-input
                                    v-model="form.tip"
                                    placeholder="请输入提示语"
                                    :addon-after="form.tip.length + '/60'"
                                    @change="inputChange('tip', 60)"
                                />
                            </a-form-model-item>
                            <a-form-model-item label="客服二维码" prop="kfQrcode">
                                <div class="dir_left_wrap cross_center">
                                    <a-upload
                                        accept=".jpg, .jpeg, .png"
                                        :action="`${baseUrl}/material/upload_cover`"
                                        :headers="headers"
                                        :showUploadList="false"
                                        :before-upload="beforeUpload"
                                        @change="uploadCoverChangeKf"
                                    >
                                        <div class="upload_list_item" v-if="form.kfQrcode">
                                            <div class="upload_list_item_info">
                                                <a-spin v-if="kfLoading">
                                                    <a-icon slot="indicator" type="loading" spin />
                                                </a-spin>
                                                <img
                                                    :src="form.kfQrcode"
                                                    width="80"
                                                    height="80"
                                                    v-else
                                                />
                                                <span
                                                    class="upload_list_item_icon base_font_size_12"
                                                    style="margin-left: 5px;"
                                                >
                                                    <a-icon type="upload"></a-icon> 修改
                                                </span>
                                            </div>
                                        </div>
                                        <a-button :loading="kfLoading" icon="upload" v-else>
                                            上传图片
                                        </a-button>
                                    </a-upload>
                                    <div
                                        class="base_font_color_00025 base_font_size_12"
                                        style="line-height: 1.5;padding-left: 15px;margin-top: -2px;"
                                    >
                                        支持jpg/png格式图片，大小不超过2M
                                    </div>
                                </div>
                            </a-form-model-item>
                        </template>
                    </a-form-model>
                </div>
            </div>
            <div class="right_col">
                <wxWelcome
                    dataStyle="style3"
                    :style3Data="{
                        name: form.name,
                        chat: currQcrode.chat || {},
                        guide: form.guide,
                        isTip: form.isTip,
                        logo: form.logo
                    }"
                >
                </wxWelcome>
            </div>
        </div>
        <div class="affix_style" v-if="type === 'update'">
            <a-affix class="affix_wrapper" :style="collapsed ? 'left:110px' : 'left: 230px'">
                <a-space>
                    <a-button @click="toStatus(2)">取消</a-button>
                    <a-button type="primary" @click="updateGroupQrcode(form)">确认</a-button>
                </a-space>
            </a-affix>
        </div>
    </div>
</template>

<script>
import api from '@/apis';
import _ from 'lodash';
import { mapState } from 'vuex';
import wxWelcome from '@/components/common/base/wx_welcome';
export default {
    // 群聊管理组件
    name: 'group_chat_manage',
    props: {
        // 当前群码信息
        currQcrode: {
            type: Object,
            default: () => {}
        },
        // 当前页状态参数
        status: {
            type: Object,
            default: () => {}
        },
        // 组件类型 update: 更新群码组件；add: 新建群码组件
        type: {
            type: String,
            default: 'update'
        }
    },
    components: {
        wxWelcome
    },
    data() {
        return {
            baseUrl: process.env.VUE_APP_BASEURL,
            headers: {},
            form: {
                id: null,
                name: '',
                scene: '',
                guide: '',
                logo: '',
                owner: '',
                isTip: 0,
                tip: '',
                kfQrcode: '',
                number: 0,
                chatId: []
            },
            loading: false,
            kfLoading: false,
            formOver: {
                name: '',
                scene: '',
                guide: ''
            },
            formRule: {
                name: [{ required: true, message: '请输入群码名称', trigger: 'change' }],
                scene: [{ required: true, message: '请输入使用场景', trigger: 'change' }]
            }
        };
    },
    created() {},
    computed: {
        ...mapState({
            collapsed: (state) => state.collapsed
        })
    },
    watch: {},
    mounted() {
        if (this.status.show) {
            const token = window.sessionStorage.getItem('token');
            this.headers.Authorization = `Bearer ${token}`;
            if (this.type === 'add') {
                const userid = window.sessionStorage.getItem('userName');
                this.form.owner = userid;
            }
            if (Object.keys(this.currQcrode) && Object.keys(this.currQcrode).length > 0) {
                Object.keys(this.form).forEach((key) => {
                    Object.keys(this.currQcrode).forEach((curKey) => {
                        if (key === curKey) {
                            this.form[key] = this.currQcrode[curKey];
                        }
                    });
                });
            }
        }
    },
    methods: {
        inputChange(sub, num) {
            if (this.form[sub].length === num) {
                this.formOver[sub] = this.form[sub];
            } else if (this.form[sub].length > num) {
                this.form[sub] = this.formOver[sub];
            }
            this.backData(this.form);
        },
        backData(data) {
            if (this.type === 'add') {
                this.$emit('backChangeForm', data);
            }
        },
        // 上传图片赋值
        uploadCoverChange({ file }) {
            const curr = this.form;
            if (file.status === 'uploading') this.loading = true;
            if (file.status === 'done') {
                this.loading = false;
                const res = file.response;
                if (res.code === 0) {
                    curr.logo = res.url;
                    this.backData(curr);
                }
            }
        },
        uploadCoverChangeKf({ file }) {
            const curr = this.form;
            if (file.status === 'uploading') this.kfLoading = true;
            if (file.status === 'done') {
                this.kfLoading = false;
                const res = file.response;
                if (res.code === 0) {
                    curr.kfQrcode = res.url;
                    this.backData(curr);
                }
            }
        },
        // 上传图片限制
        beforeUpload(file) {
            const isJPG =
                file.type === 'image/png' ||
                file.type === 'image/jpeg' ||
                file.type === 'image/jpg';
            if (!isJPG) {
                this.$message.error('您只能上传JPG/PNG图片！');
            }
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
                this.$message.error('上传的图片必须小于2MB！');
            }
            return isJPG && isLt2M;
        },
        // 无法进群提示
        changeSwitch(e) {
            this.form.isTip = e ? 1 : 0;
            this.backData(this.form);
        },
        // 去群聊管理
        toStatus(num) {
            if (num) this.$emit('toChat', num, this.currQcrode);
        },
        // 更新群码信息
        async updateGroupQrcode(listData) {
            if (this.type !== 'update') return this.$message.error(`当前组件只支持更新`);
            try {
                const params = {};
                if (listData) {
                    if (!listData.id) return this.$message.error(`未传参id`);
                    if (listData.id) params.groupId = listData.id;
                    if (listData.name) params.name = listData.name;
                    if (listData.scene) params.scene = listData.scene;
                    if (listData.guide) params.guide = listData.guide;
                    if (listData.logo) params.logo = listData.logo;
                    if (listData.isFull && listData.isFull !== 0 && listData.isFull !== 1)
                        return this.$message.error(`是否满员传参错误`);
                    if (listData.isFull || listData.isFull === 0) params.isFull = listData.isFull;
                    if (listData.isTip && listData.isTip !== 0 && listData.isTip !== 1)
                        return this.$message.error(`无法进群提示传参错误`);
                    if (listData.isTip || listData.isTip === 0) params.isTip = listData.isTip;
                    if (listData.tip) params.tip = listData.tip;
                    if (listData.kfQrcode) params.kfQrcode = listData.kfQrcode;
                }
                console.log(params);
                const res = await api.updateGroupQrcode(params);
                if (res.code !== 0) return this.$message.error(`获取企业微信群码列表报错`);
                this.$message.success(`更新成功`);
                Object.keys(params).forEach((key) => {
                    Object.keys(this.currQcrode).forEach((curKey) => {
                        if (key === curKey && key !== 'groupId') {
                            this.currQcrode[curKey] = params[key];
                        }
                    });
                });
                this.toStatus(2);
            } catch (err) {
                console.log(err);
            }
        }
    }
};
</script>

<style scoped>
#group_detail_edit {
    overflow: auto;
    height: calc(100vh - 369px);
}
#group_detail_edit::-webkit-scrollbar {
    display: none;
}
#group_detail_edit .affix_style {
    width: 100%;
    height: 52px;
}
#group_detail_edit .affix_style .affix_wrapper {
    position: fixed;
    bottom: 81px;
    right: 47px;
    background: #fff;
    padding: 10px 30px;
    transition: all 0.2s;
}
#group_detail_edit .left_col {
    padding: 0 6% 0 0;
    width: calc(95% - 260px);
}
#group_detail_edit .right_col {
    width: 260px;
}
</style>
